<template>
  <v-alert
    text
    color="primary"
    icon="mdi-alert-circle"
    border="left"
  >
    <slot></slot>
  </v-alert>
</template>

<script>
export default {
  name: 'InfoAlert'
}
</script>
